import { createGlobalState } from "react-hooks-global-state";
export var initialState = {
    pendingTransactions: [],
    showConnectWallet: false,
    gasPrice: "",
    desktopView: "grid",
    airdropInfo: undefined,
    vaultPositionModal: {
        show: false,
        vaultVersion: "v2",
    },
    vaultPauseModal: {
        show: false,
        vaultVersion: "v2",
    },
    vaultResumeModal: {
        show: false,
        vaultVersion: "v2",
    },
    showEarnVault: {
        show: false,
    },
    notificationLastReadTimestamp: undefined,
    componentRefs: {
        header: undefined,
        footer: undefined,
    },
};
export var useGlobalState = createGlobalState(initialState).useGlobalState;
//# sourceMappingURL=store.js.map